/*
saikrishna 10/03/2022 2698823069 Feature: Added three fields in multiple places wherever required in client management
saikrishna 10/04/2022 2698823069 bugFix: fixexed bugs in column names
akhila 11/03/2022 2698823069 TablePagination bugFix
Ashraf 11/15/2022 2698823069 Fixed active color issue

*/

import React, {useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {tablePageRowsRate, defaultRows} from '../../../../constants/ReusableTablePagination';
import {tableIcons} from '../../../../components/TableIcons';
import DialogBox from '../../../../components/DialogBox';
import moment from 'moment';
import {useHistory} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import MouseOverPopover from '../../../../components/MousePopOver/MousePopOver';
import EditSubServiceTypeDialog from '../../ClientSearch/EditSubServiceTypeDialogcp';
import {
  deleteRate,
  fetchRateHistoryData,
  resetDateValidation,
  resetHistoryData,
  resetStatusCode,
  startDateValidationApi,
} from '../../../../redux/reducers/ClientRateHistory';
import {
  resetMessage,
} from '../../../../redux/reducers/client-maintainance/ClientGeneral';
import HistoryDialog from '../../ClientSearch/HistoryDialog';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../components/PageLoader';
import {SuccessSnackbar} from '../../../../components/CustomSnackBar';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {TablePagination} from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const formatNumber = (val, type) => {
  if (type === 'flat') {
    return <div>$&nbsp;{val?.toFixed(2)}</div>;
  } else {
    return <div>{val?.toFixed(2)}&nbsp;%</div>;
  }
};

const SubServiceTypeTable = ({
  setRowData,
  firstLetterCap,
  // setEditSubServiceDialog,
  historyData,
}) => {
  const {clientGeneralData, clientFetchStatus} = useSelector(({clientGeneral}) => clientGeneral);
  const dispatch = useDispatch();
  const changeFlatVal = (val) => (val === 'flat' ? 'Flat Fee' : firstLetterCap(val));
  const {roleData} = useSelector(({role}) => role);
  const columns = [
    {
      title: 'Sub Service Type',
      field: 'subServiceType',
      cellStyle: {
        minWidth: '450px',
      },
    },
    {
      title: 'Rate Type',
      field: 'feeType',
      minWidth: '150px',
      render: (rowData) => {
        return changeFlatVal(rowData.feeType);
      },
    },
    {
      title: 'Value',
      field: 'feeValue',
      minWidth: '150px',
      render: (rowData) => formatNumber(rowData.feeValue, rowData.feeType),
    },
    {
      title: 'Effective Date',
      field: 'serviceStartDt',
      minWidth: '150px',
      customFilterAndSearch: (term, rowData) => {
        if (moment(rowData.serviceStartDt).format('MM/DD/YYYY').includes(term)) {
          return moment(rowData.serviceStartDt).format('MM/DD/YYYY');
        }
      },
      render: (rowData) => {
        return moment(rowData.serviceStartDt).format('MM/DD/YYYY');
      },
    },
    {
      title: 'End Date',
      field: 'serviceEndDt',
      minWidth: '150px',
      customFilterAndSearch: (term, rowData) => {
        if (moment(rowData.serviceEndDt).format('MM/DD/YYYY').includes(term)) {
          return moment(rowData.serviceEndDt).format('MM/DD/YYYY');
        }
      },
      render: (rowData) => {
        return rowData.serviceEndDt ? moment(rowData.serviceEndDt).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Debtor Over Payments Remitted',
      field: 'paymentsRemitted',
      maxWidth: '250px',
      render: (rowData) => (
        <>
          { rowData.paymentsRemitted === 'send' ? 'Send' : 'Don\'t Send'}
        </>
      ),
    },
    {
      title: 'Inflation Agreement',
      field: 'inflationAgreement',
      maxWidth: '250px',
      render: (rowData) => (
        <>
          {rowData.inflationAgreement}
        </>
      ),
    },
    {
      title: 'Postage Agreement',
      field: 'postageAgreement',
      maxWidth: '250px',
      render: (rowData) => (
        <>
          {rowData.postageAgreement}
        </>
      ),
    },
    {
      title: 'Notes',
      field: 'rateNotes',
      maxWidth: '250px',
      render: (rowData) => (
        <>
          {rowData.rateNotes ? (
            <MouseOverPopover
              data={rowData.rateNotes}
              popOverData={rowData.rateNotes}
              codeLength={rowData?.rateNotes?.length}
            />
          ) : (
            '-'
          )}
        </>
      ),
    },
  ];

  const tableData =
    clientGeneralData['subServiceType'] &&
    clientGeneralData['subServiceType'].map((data) => {
      return {
        ...data,
        tableData: {id: data.subServiceTypeId},
      };
    });
  // const handleEditRow = (data, service) => {
  //   let row = { ...data, subscribedService: true };
  //   setEditSubServiceDialog(true);
  //   setRowData(row);
  // };
  const [rows, setRows] = useState(defaultRows);
  const [rowData1, setRowData1] = useState();
  const [editSubServiceDialog, setEditSubServiceDialog] = useState(false);
  const [historyDialog, setHistoryDialog] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [clientRatecardId, setclientRatecardId] = useState('');
  const history = useHistory();

  const {successMsg, isLoading, deleteRateStatus} = useSelector(
    ({clientRateHistory}) => clientRateHistory,
  );

  useEffect(() => {
    if (deleteRateStatus === 200) {
      setTimeout(() => {
        dispatch(resetStatusCode());
      }, 2500);
    }
  }, [deleteRateStatus]);
  const handleEditRow = (data, service) => {
    const payLoadStartDateValidaion = {
      clientNumber: clientGeneralData?.clientNumber,
      subServiceType: data?.subServiceType,
    };
    dispatch(startDateValidationApi(payLoadStartDateValidaion));

    const reqArr = [];
    clientGeneralData['subServiceType'].map((each2) => {
      if (
        data?.companyType === each2?.companyType &&
        data?.serviceType === each2?.serviceType &&
        data?.subServiceType === each2?.subServiceType
      ) {
        reqArr.push(each2);
      }
    });

    let row;
    if (service === 'subscribed') {
      row = {...data, subscribedService: true};
    } else {
      row = {...data, subscribedService: false};
    }
    setRowData1(row);
    // if (data.isCurrentRate) {
    setEditSubServiceDialog(true);
    // } else {
    //   setEditSubServiceDialogFuture(true);
    //   setPrePopData(data);
    // }
  };

  const getDisableEditSubscribe = (subService) => {
    const futureDisableObject = {};
    const reqArrForDisableEdit = [];

    clientGeneralData?.subServiceType?.forEach((each2) => {
      // each?.subServiceTypeListResponses &&
      // each?.subServiceTypeListResponses.map((each2) => {
      if (
        subService?.companyType === each2?.companyType &&
        subService?.serviceType === each2?.serviceType &&
        subService?.subServiceType === each2?.subServiceType
      ) {
        reqArrForDisableEdit.push(each2);
      }
      // });
    });
    reqArrForDisableEdit &&
      reqArrForDisableEdit.length > 0 &&
      reqArrForDisableEdit.forEach((each) => {
        if (
          Object.keys(futureDisableObject)?.length === 0 ||
          (futureDisableObject &&
            Object.keys(futureDisableObject)?.length > 0 &&
            each?.serviceStartDt > futureDisableObject[each?.subServiceType][0]?.serviceStartDt)
        // each?.serviceEndDt > futureDisableObject[each?.subServiceType][0]?.serviceEndDt)
        ) {
          futureDisableObject[each?.subServiceType] = [each];
        }
      });
    if (Object.keys(futureDisableObject).includes(subService?.subServiceType)) {
      if (
        futureDisableObject[subService?.subServiceType][0]?.serviceStartDt ===
          subService?.serviceStartDt &&
        futureDisableObject[subService?.subServiceType][0]?.serviceEndDt ===
          subService?.serviceEndDt
      ) {
        return false;
      }
      return true;
    }
    return true;
  };

  const handleSubServiceDialog = () => {
    setEditSubServiceDialog(false);
    dispatch(resetDateValidation());
  };

  const handleHistoryDialog = () => {
    setHistoryDialog(false);
    setTimeout(() => {
      dispatch(resetHistoryData());
    }, 500);
  };

  useEffect(() => {
    if (clientFetchStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        clientGeneralData['subServiceType']?.length === 0 &&
        history.push({
          pathname: `/client-search`,
        });
      }, 2000);
    }
  }, [clientFetchStatus, clientGeneralData]);


  const handleHistory = (data, service) => {
    const details = {
      clientId: clientGeneralData?.clientNumber,
      subServiceType: data.subServiceType,
    };
    dispatch(fetchRateHistoryData(details));
    // setRowDataHistory(data.subServiceTypeHistory);
    setHistoryDialog(true);
  };

  const handleDelete = (rateData) => {
    setIsDelete(true);
    setclientRatecardId(rateData?.clientRatecardId);
  };

  const handleDeleteSubmit = () => {
    dispatch(deleteRate(clientRatecardId));
    setIsDelete(false);
  };

  const handleCloseDialogDelete = () => {
    setIsDelete(false);
  };
  return (
    <>
      <div className="custom-table clientMaintenance-field-table">
        <GuiTable
          columns={columns}
          data={tableData}
          title={
            <div>
              <h2 className="table-heading">Subscribed Services</h2>
            </div>
          }
          icons={tableIcons}
          options={{
            filtering: false,
            pageSize: rows,
            pageSizeOptions: tablePageRowsRate,
            search: true,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
            rowStyle: (rowData) => {
              return {
                backgroundColor: rowData?.isCurrentRate ? '#90ee90' : '#fff',
              };
            },
          }}
          // detailPanel={[
          //   {
          //     tooltip: "Show History",
          //     render: (rowData) => {
          //       const history = rowData.subServiceTypeHistory ? rowData.subServiceTypeHistory : [];
          //       return (
          //         <>
          //           {history.length > 0 ? (
          //             history.map((el) => {
          //               const formatDate = (date) => moment(date).format("MM/DD/YYYY");
          //               const feeValue = formatNumber(el.feeValue, el.feeType);
          //               return (
          //                 <>
          //                   <table className="subservice-table">
          //                     <tr>
          //                       <td colSpan={3}></td>
          //                       <td>{changeFlatVal(el.feeType)}</td>
          //                       <td>{feeValue}</td>
          //                       <td>{formatDate(el.serviceStartDt)}</td>
          //                       <td>{formatDate(el.serviceEndDt)}</td>
          //                       <td>{el.rateNotes}</td>
          //                     </tr>
          //                   </table>
          //                 </>
          //               );
          //             })
          //           ) : (
          //             <div className="py-2 text-center bg-light">No History</div>
          //           )}
          //         </>
          //       );
          //     },
          //   },
          // ]}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={[15, 50, 100]}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
          actions={[
            (rowData) =>
              !getDisableEditSubscribe(rowData) ?
                {
                  icon: () => <EditOutlinedIcon/>,
                  tooltip: 'Edit',
                  disabled: !roleData?.window?.['Client Maintenance']?.CG?.edit,
                  onClick: (event, rowData) => {
                    handleEditRow(rowData, 'subscribed');
                  },
                } :
                {
                  icon: '',
                  tooltip: '',
                  disabled: true,
                },
            (rowData) => ({
              icon: 'history',
              tooltip: 'History',
              // disabled: !roleDataClientMaintenance?.CG?.edit || rowData?.serviceEndDt,
              onClick: (event, rowData) => {
                handleHistory(rowData, 'subscribed');
              },
            }),
            (rowData) =>
              !getDisableEditSubscribe(rowData) && !rowData?.isCurrentRate ?
                {
                  icon: 'delete',
                  tooltip: 'Delete',
                  disabled: !roleData?.window?.['Client Maintenance']?.CG?.delete,
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                } :
                {
                  icon: '',
                  tooltip: '',
                  disabled: true,
                },
          ]}
        />
      </div>
      <DialogBox
        open={editSubServiceDialog}
        title="Edit Rate"
        maxWidth={'md'}
        dialogClose={handleSubServiceDialog}
      >
        <EditSubServiceTypeDialog
          rowData={rowData1}
          parentRowData={clientGeneralData}
          clientNumber={'clientNumber'}
          handleSubServiceDialog={handleSubServiceDialog}
          setEditSubServiceDialog={setEditSubServiceDialog}
        />
      </DialogBox>
      {/* future popup */}
      {/* <DialogBox
        open={editSubServiceDialogFuture}
        title="Edit Rate"
        maxWidth={"md"}
        dialogClose={handleSubServiceDialogFuture}
      >
        <EditSubServiceTypeDialogFuture
          rowData={rowData1}
          parentRowData={clientGeneralData}
          prePopData={prePopData}
          clientNumber={"clientNumber"}
          handleSubServiceDialog={handleSubServiceDialogFuture}
          setEditSubServiceDialog={setEditSubServiceDialogFuture}
          futureEffeciveValidationArr={futureEffeciveValidationArr}
        />
      </DialogBox> */}
      <DialogBox
        open={historyDialog}
        title="History"
        maxWidth={'xl'}
        dialogClose={handleHistoryDialog}
      >
        <HistoryDialog/>
      </DialogBox>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialogDelete}
        title="Delete Rate"
        value={`Are you sure you want to delete this Rate?`}
        handleSubmit={handleDeleteSubmit}
      />
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default SubServiceTypeTable;
